import type { FullStore } from '../types'
import type { Drawer, DrawerActions, DrawerState } from './types'

import type { StateCreator } from 'zustand'

const createDefaultDrawer = (drawers: Drawer[]): Drawer => {
    return {
        open: true,
        index: drawers.length,
        placement: 'right',
    }
}

export const createDrawerSlice: StateCreator<FullStore, [], [], DrawerState & DrawerActions> = (set) => ({
    drawers: [],

    addDrawer: (drawer) =>
        set((state) => ({
            drawers: [
                ...state.drawers,
                {
                    ...createDefaultDrawer(state.drawers),
                    ...drawer,
                },
            ],
        })),

    removeDrawer: (targetIndex) =>
        set((state) => {
            const remainingDrawers = state.drawers.filter((_, drawerIndex) => {
                return drawerIndex !== targetIndex
            })

            const reindexedDrawers = remainingDrawers.map((drawer, drawerIndex) => {
                return { ...drawer, index: drawerIndex }
            })

            return { drawers: reindexedDrawers }
        }),

    toggleDrawer: (targetIndex) =>
        set((state) => ({
            drawers: state.drawers.map((drawer, drawerIndex) => {
                if (drawerIndex === targetIndex) {
                    return { ...drawer, open: !drawer.open }
                }
                return drawer
            }),
        })),

    clearAllDrawers: () => set({ drawers: [] }),

    updateDrawer: (targetIndex, updates) =>
        set((state) => ({
            drawers: state.drawers.map((drawer, drawerIndex) => {
                if (drawerIndex === targetIndex) {
                    return { ...drawer, ...updates }
                }
                return drawer
            }),
        })),
})
